"use strict";
exports.__esModule = true;
var get_style_1 = require("./get-style");
function getHeight(el, defaultValue) {
    var height = get_style_1["default"](el, 'height', defaultValue);
    if (height === 'auto') {
        height = el.offsetHeight;
    }
    return parseFloat(height);
}
exports["default"] = getHeight;
//# sourceMappingURL=get-height.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/dom-util/lib/get-height.js
// module id = 590
// module chunks = 37